import React, { useState } from "react";
import "./CookieNotice.css";

const COOKIE_NOTICE_KEY = "cookie_notice_dismissed";

function CookieNotice() {
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(COOKIE_NOTICE_KEY) === "1";
    } catch (error) {
      return false;
    }
  });

  const closeNotice = () => {
    setHidden(true);
    try {
      localStorage.setItem(COOKIE_NOTICE_KEY, "1");
    } catch (error) {
      // Ignore storage errors and just hide for this session.
    }
  };

  if (hidden) return null;

  return (
    <div className="cookie-notice" role="status" aria-live="polite">
      <button
        type="button"
        className="cookie-notice-close"
        onClick={closeNotice}
        aria-label="Затвори известување за колачиња"
      >
        ×
      </button>
      <p className="cookie-notice-text">
        Оваа веб-страница користи колачиња за подобро корисничко искуство. Со
        користење на страницата, се согласувате со употребата на колачиња.
      </p>
    </div>
  );
}

export default CookieNotice;
